<template>
  <div>
    <div class="message-news" :style="'width: '+ width + 'px; height: '+ height + 'px;'" alt="点击查看商品" @click="handleClick">
      <div class="message-news-image">
        <img :src="fileBaseUrl+news.coverImg" width="100%" height="100%">
      </div>
      <div class="message-news-content">
        <div class="message-news-title" :style="'color: '+news.titleColor+';'">
          {{news.title}}
        </div>
        <div class="message-news-address">
          {{news.titleAddress}}
        </div>
        <div v-if="news.isShowCreatedTime==='1'" class="message-news-datetime">
          {{news.datetime}}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "MessageNews",
  props: {
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    },
    newsStr: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      fileBaseUrl: process.env.VUE_APP_FILE_BASE_URL,
      news: null
    }
  },
  created() {
    console.log(this.newsStr)
    this.news = JSON.parse(this.newsStr)
  },
  methods: {
    handleClick(){
      this.$emit("click", this.news)
    },
  }
}
</script>

<style scoped lang="scss">
@import "MessageNews";
</style>